import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgTriangleDownLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M7.02 10.875C6.347 9.708 7.19 8.25 8.536 8.25h6.928c1.347 0 2.19 1.458 1.516 2.625l-3.464 6c-.674 1.167-2.358 1.167-3.031 0zM8.536 9.75a.25.25 0 0 0-.217.375l3.464 6a.25.25 0 0 0 .434 0l3.464-6a.25.25 0 0 0-.217-.375z'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgTriangleDownLine)
export default ForwardRef
